import { c as _c } from "react/compiler-runtime";
import { stringify } from 'querystring';
import { Box, chakra } from '@chakra-ui/react';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React, { useMemo } from 'react';
export const IntroCallStep = props => {
  const $ = _c(6);
  const {
    currentUser
  } = useCurrentUser();
  const t0 = currentUser?.firstName;
  const t1 = currentUser?.lastName;
  const t2 = currentUser?.email;
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = stringify({
      firstName: t0,
      lastName: t1,
      email: t2
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const hubspotUrl = `https://go.startups.com/meetings/justin-chagin/fg-onboarding-?embed=true&${t3}`;
  let t4;
  if ($[4] !== hubspotUrl) {
    t4 = <Box width="full"><chakra.iframe borderRadius="1em" display="block" maxWidth="100%" minHeight="660px" src={hubspotUrl} width="full" /></Box>;
    $[4] = hubspotUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};